import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {FormSection, formComponent} from 'iss/widgets/Forms';
import {SelectableTable} from 'iss/widgets/SelectableTable';
import {formatLocationNameAndCode} from 'iss/widgets/format/Site';

export const SelectableContractEditor = formComponent(class SelectableContractEditor extends React.Component {
  state = { selectedContracts: [] };
  render() {
    const {value, children} = this.props;
    return children({
      selectedContracts: this.state.selectedContracts,
      onSelectContracts: this.onSelectContracts,
      values: value,
      getContractValue: this.getContractValue,
      selectedValues: this.getSelectedValues(),
      updateSelectedValues: this.updateSelectedValues,
      ContractSelectorTable: contractSettingsTable(this.state.selectedContracts, this.onSelectContracts),
    });
  }
  onSelectContracts = (t) => {
    this.setState({selectedContracts: t});
  };
  getContractValue = (contract) => {
    return R.propOr(this.props.defaultValue, contract.id, this.props.value);
  };
  getSelectedValues = () => {
    return this.state.selectedContracts.map(this.getContractValue);
  };
  updateSelectedValues = (updater) => {
    const newParties = R.fromPairs(this.state.selectedContracts.map(contract => [
      contract.id,
      updater(this.getContractValue(contract))
    ]));
    this.props.onChange(R.mergeRight(this.props.value, newParties));
  };
}, {pure: false});

export const siteNameColumn = {
  header: translate('evaluationActivator.evaluationSite'),
  accessor: ({location, site})=> {
    return location ?
      `${site.name}, ${formatLocationNameAndCode(location)}` :
      site.name;
  }
};

export function contractSettingsTable(selectedContracts, onSelectContracts) {
  return ({columns, ...props}) => <FormSection>{
    ({contracts}) =>
      <SelectableTable {...props} data={contracts}
        selected={selectedContracts} onChangeSelected={onSelectContracts}
        columns={[siteNameColumn].concat(columns)}
        />
  }</FormSection>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/activation/SelectableContractEditor.jsx